<template>
    <div class="hero__content" :class="{'hero__content--video' : hero_is_video}">
        <div class="hero_img_container">
            <video autoplay muted loop class="hero__deco hero__deco--video" v-if="hero_is_video" >
                <source :src="home_hero_desktop_video" type="video/mp4">
            </video>
            <img v-else class="hero__deco" :src="home_hero_desktop_image"
                 :alt="home_hero_alt">
        </div>
        <div class="composition_tag" v-if="has_composition_tag"><img src="/images/composition_tags/tag_nl.png" alt="aanbod 2€/2 maaden"></div>
    </div>
</template>

<script>
import image_mixin from "../../_commons/nl/mixins/image_mixin"

export default {
    mixins: [
        image_mixin
    ]
}
</script>

<style scoped>

</style>
